import { useMemo } from "react";
import { useSelector } from "react-redux";
import { buildContactSelectionSummary } from "../../utils/contactSelectionSummary.js";
import classes from "./contactSelectionChips.module.scss";

const ContactSelectionChips = ({ className, allowedKeys }) => {
  const companyStore = useSelector((state) => state.company_store);
  const chips = useMemo(
    () => buildContactSelectionSummary(companyStore, allowedKeys),
    [companyStore, allowedKeys],
  );

  if (!chips.length) {
    return null;
  }

  return (
    <div className={`${classes.root} ${className || ""}`.trim()}>
      {chips.map((chip) => (
        <span key={`${chip.category}-${chip.value}`} className={classes.chip}>
          {chip.category}: {chip.value}
        </span>
      ))}
    </div>
  );
};

export default ContactSelectionChips;
